import { Component, inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { LoginFormComponent } from '../../components/login-form/login-form.component';
import { Router } from '@angular/router';
import { User } from '../../../core/models/entities/user';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-login-page',
  template: `
    <app-auth-template title="Connexion">
      <app-alert variant="light">
        <div class="font-bold">Rafraîchissement de votre espace admin</div>
        <app-spacer size="2"></app-spacer>
        <p
          >L'interface évolue progressivement pour plus de clarté et
          d'efficacité. <br />Certains éléments changeront d'apparence au cours
          des prochaines semaines.<br />Pas d'inquiétude : les changements sont
          purement esthétiques, toutes vos fonctionnalités restent accessibles
          comme avant.</p
        >
      </app-alert>

      <app-spacer size="6"></app-spacer>

      <app-login-form
        [sendingData]="sendingData"
        (afterLogin)="afterLogin($event)"
      ></app-login-form>
    </app-auth-template>
  `,
  standalone: false,
})
export class LoginPageComponent {
  @ViewChild(LoginFormComponent) loginForm: LoginFormComponent;
  sendingData: boolean;
  platformId = inject(PLATFORM_ID);

  constructor(
    private router: Router,
    private title: Title,
  ) {
    this.title.setTitle('Location de salles - Se connecter');
  }

  async afterLogin(user: User) {
    const { redirect } = window.history.state;

    if (redirect) {
      await this.router.navigateByUrl(redirect);
    } else {
      await this.router.navigate(['/reservations']);
    }
  }
}
